<mat-card>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <h3 class="page-header">Stale Subscriptions</h3>
    <button mat-icon-button (click)="loadStaleSubscriptions()" type="button" matTooltip="Refresh" [disabled]="isLoading">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-title>
  <mat-card-content style="min-height: 500px;">
    <p>These email subscriptions were disabled because their screenshot can no longer be taken. No emails are sent for them.</p>
    <div *ngIf="isLoading" fxLayout="row" fxLayoutAlign="center center" style="padding: 40px;">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="!isLoading">

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let row">{{ row.title }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row">{{ row.type | titlecase }}</td>
      </ng-container>

      <ng-container matColumnDef="emailTo">
        <th mat-header-cell *matHeaderCellDef>Email To</th>
        <td mat-cell *matCellDef="let row">{{ row.emailTo }}</td>
      </ng-container>

      <ng-container matColumnDef="frequency">
        <th mat-header-cell *matHeaderCellDef>Frequency</th>
        <td mat-cell *matCellDef="let row">{{ row.frequency === 'month' ? 'Monthly' : 'Weekly' }}</td>
      </ng-container>

      <ng-container matColumnDef="staleReason">
        <th mat-header-cell *matHeaderCellDef>Reason</th>
        <td mat-cell *matCellDef="let row">{{ getReasonLabel(row) }}</td>
      </ng-container>

      <ng-container matColumnDef="staleAt">
        <th mat-header-cell *matHeaderCellDef>Disabled On</th>
        <td mat-cell *matCellDef="let row">{{ row.staleAt | date:'mediumDate' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="warn" (click)="deleteSubscription(row)" title="Delete" type="button"
            *ngIf="canDelete">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [colSpan]="displayedColumns.length" style="text-align: center; padding: 24px;">
          <div class="no-data">No stale subscriptions found.</div>
        </td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
